

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M1.51672 15.8996C1.12445 15.9224 0.738661 15.792 0.440711 15.5359C-0.146904 14.9448 -0.146904 13.9901 0.440711 13.399L13.3076 0.532122C13.9187 -0.0397716 14.8778 -0.00798041 15.4496 0.603191C15.9668 1.15587 15.9969 2.00535 15.5202 2.59327L2.57757 15.5359C2.28346 15.7883 1.90386 15.9185 1.51672 15.8996Z","fill":"#342245"}, []), "\n", h('path', {"d":"M14.3684 15.8997C13.9708 15.898 13.5898 15.7402 13.3075 15.4602L0.440589 2.59325C-0.103806 1.95752 -0.0297926 1.00079 0.605933 0.456346C1.17334 -0.0295566 2.01014 -0.0295566 2.57749 0.456346L15.5201 13.3232C16.1312 13.8953 16.1628 14.8543 15.5907 15.4654C15.568 15.4897 15.5444 15.5132 15.5201 15.5359C15.2032 15.8115 14.7861 15.9432 14.3684 15.8997Z","fill":"#342245"}, []), "\n"]);
};

        